import React from 'react';

export type TriageCategoryBadgeVariant = 'short' | 'long';

export interface TriageCategoryBadgeProps {
  category: number | null | undefined;
  variant?: TriageCategoryBadgeVariant;
  showApproved?: boolean;
  showEdited?: boolean;
  className?: string;
  title?: string;
}

/**
 * TriageCategoryBadge - Displays a triage category badge with consistent styling
 * 
 * @example
 * <TriageCategoryBadge category={1} variant="short" />
 * <TriageCategoryBadge category={2} variant="long" showApproved />
 * <TriageCategoryBadge category={3} showEdited />
 */
export const TriageCategoryBadge: React.FC<TriageCategoryBadgeProps> = ({
  category,
  variant = 'short',
//   showApproved = false,
  showEdited = false,
  className = '',
  title,
}) => {
  const categoryNumber = category || 0;
  const prefix = variant === 'short' ? 'P' : 'Priority';
  const displayText = categoryNumber > 0 ? `${prefix} ${categoryNumber}` : `${prefix} N/A`;

  const classes = [
    'triage-badge',
    `category-${categoryNumber}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={classes} title={title}>
      {displayText}
      {showEdited && categoryNumber > 0 && (
        <span className="triage-edited-indicator"> (Edited)</span>
      )}
      {/* {showApproved && ' ✓'} */}
    </span>
  );
};

